import { CognitoConstants, NcrType } from '../../constants.js'
import { defaultObj } from './state'

export default {
  setReferralInfo (state, data) {
    if (data.currentBalance) {
      state.currentBalance = data.currentBalance
    }

    if (data.referralUrl) {
      state.referralUrl = data.referralUrl
    }

    if (data.shortCode) {
      state.shortCode = data.shortCode
    }

    if (data.peopleSignedUp) {
      state.peopleSignedUp = data.peopleSignedUp
    }

    if (data.pendingCashOut) {
      state.pendingCashOut = data.pendingCashOut
    }
  },

  setReferralToActive (state) {
    state.ncrCognitoAttribute = NcrType.customer
  },

  setReferralStatus (state, data) {
    const ncrAttribute = data.find(attr => attr.getName() === CognitoConstants.ncrAttribute)
    if (ncrAttribute !== undefined && ncrAttribute.Value !== undefined) {
      state.ncrCognitoAttribute = ncrAttribute.Value
    }
  },

  setReferralStats (state, data) {
    if (data.peopleSignedUp !== undefined) {
      state.peopleSignedUp = data.peopleSignedUp
    }

    if (data.codesScanned !== undefined) {
      state.referCodesScanned = data.codesScanned
    }

    if (data.amountPerShare) {
      state.amountPerShare = data.amountPerShare
    }
  },

  setBalanceHistory (state, data) {
    if (Array.isArray(data)) {
      state.balanceHistory = data
    }
  },

  setDisburseCardData (state, data) {
    if (data.cardId !== undefined) {
      state.cardId = data.cardId
    }

    if (data.cardName) {
      state.cardName = data.cardName
    }

    if (data.cardNumber) {
      state.cardNumber = data.cardNumber.slice(-4)
    }

    if (data.cardType) {
      state.cardType = data.cardType
    }

    if (data.disbursementAmount) {
      state.disbursementAmount = data.disbursementAmount
    }
  },

  reset (state) {
    if (this.cache.has('referral/getReferralStats') === true) {
      this.cache.delete('referral/getReferralStats')
    }

    if (this.cache.has('referral/getBalanceHistory') === true) {
      this.cache.delete('referral/getBalanceHistory')
    }

    state = Object.assign(state, defaultObj)
  }
}
